export const SELLER_CODE_ATTRIBUTE = 'Sagefy_Seller'

const STORAGE_KEY = 'sagefy_seller'

function getStorage () {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null
  } catch (e) {
    return null
  }
}

function readEntry (storage) {
  try {
    return JSON.parse(storage.getItem(STORAGE_KEY))
  } catch (e) {
    return null
  }
}

export function saveSellerCode (checkoutId, sellerCode) {
  const storage = getStorage()
  if (!storage || !checkoutId || !sellerCode) return
  storage.setItem(STORAGE_KEY, JSON.stringify({ checkoutId, sellerCode }))
}

export function getSellerCode (checkoutId) {
  const storage = getStorage()
  if (!storage || !checkoutId) return ''
  const entry = readEntry(storage)
  return entry && entry.checkoutId === checkoutId ? entry.sellerCode || '' : ''
}

export function clearSellerCode () {
  const storage = getStorage()
  if (storage) storage.removeItem(STORAGE_KEY)
}
